import axios from 'axios'

export const all = () => axios.get('v1/clinics')

export const allByCity = (city: string) => axios.get('v1/catalogo/clinics/all', {
  params: {
    city,
  },
})

export const states = () => axios.get('v1/catalogo/clinics/states')

export const cities = (state?: string) => axios.get('v1/catalogo/clinics/cities', {
  params: state ? { state } : {},
})

export const find = (id: number) => axios.get(`v1/clinics/${id}`)

export const show = (id: number) => axios.get(`v1/catalogo/clinics/${id}`)
